import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { message, Card } from 'antd';
import { loginAction } from '../../../state/actions/creators/auth.actioncreator';
import LoginForm from '../components/LoginForm';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';
import { Flex, Box, Text } from '../../shared/components';
import GIOWEB2Logo from '../../../assets/img/gioweb2_logo.svg';

class Login extends PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { username, password, dominio } = values;
    const { login } = this.props;
    login(username, password, dominio);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { estadoPeticionLogin: previousEstadoPeticionLogin } = prevProps;
    const { estadoPeticionLogin, history } = this.props;

    handleSagaStatus({
      estadoPeticion: estadoPeticionLogin,
      previousEstadoPeticion: previousEstadoPeticionLogin,
      onWasRunningAndHasSucceded: () => {
        history.replace('/');
      },
      onWasRunningAndHasFailed: () => {
        message.error('PLACEHOLDER: Ha ocurrido un problema');
      },
    });
  }

  render() {
    const { authStatus, history } = this.props;
    const { running } = authStatus || false;

    const inIframe = window.top != window.self;

    // TODO: Fixed provisional para no recargar las listas.
    sessionStorage.clear();
  
    if (inIframe) return null;

    return (
      <Flex style={{ marginTop: '-5%', backgroundColor: '#f0f2f5' }} width="100%" height="100%" justifyContent="center" alignItems="center">
        <Box height="486px">
          <Card bordered={false} className="loginCard" style={{ width: '400px' }}>
            <Box>
              <Flex alignItems="center" flexDirection="column" mt="16" mb="32">
                <img style={{ height: '48px' }} src={GIOWEB2Logo} alt="Logo" />
                <Text color="#918E87" fontSize="18" translationId="app.slogan" mt="16" />
              </Flex>
              <Box p="16">
                <LoginForm history={history} loading={running} onSubmit={values => this.onSubmit(values)} />
              </Box>
            </Box>
          </Card>
        </Box>
      </Flex>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  authStatus: PropTypes.object,
};
Login.defaultProps = {
  authStatus: null,
};

const mapStateToProps = (state) => {
  const { sagas } = state;
  return {
    estadoPeticionLogin: obtenerEstadoRequestDesdeSaga(sagas, 'AUTH'),
    authStatus: (state.sagas.AUTH !== null) ? state.sagas.AUTH : null,
  };
};

const mapDispatchToProps = dispatch => ({
  login: (username, password, dominio) => dispatch(loginAction(username, password, dominio)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
